import { useTranslation } from 'react-i18next';
import { Button, ButtonsWrapper, Modal, Typography } from '@thinknet-gmbh/platform-common-ui';

import { VACANCIES_MODALS } from 'src/pages/vacancies/vacancies.constants';
import { IVacancyConfirmationModal } from 'src/pages/vacancies/vacancies.interfaces';

import { ConfirmationModalWrapper } from './vacancy-confirmation-modal.styles';

const VacancyConfirmationModal = ({
  onClose,
  onSubmit,
  activeModal,
}: IVacancyConfirmationModal) => {
  const { t } = useTranslation(['jobs', 'vacancies', 'common']);

  const isPublish = activeModal === VACANCIES_MODALS.publishVacancy;

  return (
    <Modal
      isOpened={isPublish || activeModal === VACANCIES_MODALS.closeVacancy}
      onClose={onClose}
      title={t(`vacancies:labels.${isPublish ? 'publishVacancy' : 'closeVacancy'}`)}
      smallerPadding
    >
      <ConfirmationModalWrapper isClose={!isPublish}>
        <Typography>
          {t(`vacancies:labels.${isPublish ? 'publishModalSubtitle' : 'closeModalSubtitle'}`)}
        </Typography>
        <ButtonsWrapper marginTop={14}>
          <Button type="primary" onClick={onSubmit}>
            {isPublish ? t('jobs:buttons.publish') : t('vacancies:buttons.close')}
          </Button>
          <Button onClick={onClose}>{t('common:buttons.cancel')}</Button>
        </ButtonsWrapper>
      </ConfirmationModalWrapper>
    </Modal>
  );
};

export default VacancyConfirmationModal;
